import React from "react";

interface Props {
  value: number;
  min: number;
  max: number;
  classes: string;
  update: (value: number) => void;
}

const ValueSlider: React.FC<Props> = ({
  value,
  min,
  max,
  classes,
  update
}) => {
  const percent = (100 * value / max) + "%"


  return (
    <div className={classes}>
        <input type="range" min={min} max={max} value={value} style={{width: "100%"}} step="1"
               onChange={(e) => update(parseInt(e.target.value))}/>
    </div>
  );
};

export default ValueSlider;
